import { useTranslation } from '@crew/modules/dist/i18n'
import { CrewNavTabProps } from 'components/elements/crewNavTabs/components/crewNavTab'
import {
  CrewNavTabs,
  CrewNavTabsDirection,
} from 'components/elements/crewNavTabs/crewNavTabs'
import { ProjectDetailManagementTabs } from 'enums/app'
import { memo, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

export const ProjectDetailManagementTab = memo(() => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const displayTabItems: CrewNavTabProps[] = useMemo(() => {
    return Object.values(ProjectDetailManagementTabs).map((item) => {
      return {
        onClick: () => {
          // タブに対応するURLへ遷移（相対パス指定）
          navigate(item.value)
        },
        to: item.value,
        text: t(item.text),
        icon: undefined,
      }
    })
  }, [navigate, t])

  return (
    <CrewNavTabs
      tabItems={displayTabItems}
      direction={CrewNavTabsDirection.Vertical}
    />
  )
})
